import React, {useEffect, useState} from 'react'
import { withRouter } from 'react-router-dom'
import ReactModal from 'react-modal'
import moment from 'moment'

import {
  UserDocumentsAdd,
  UserDocumentsView,
  UserInfoAdd,
  UserAttorneyAdd
} from '../utilites/Forms'
import userScheme from '../../validation/scheme/userScheme'
import userDocumentScheme from '../../validation/scheme/userDocumentScheme'
import {
  HCheckbox,
  HookForm
} from '../../validation/HForm'
import { userService } from '../../services/user-service'
import { messages } from '../../helpers/messages'
import { Message } from '../utilites'
import { BackButton } from '../common'

import './user-add.scss'
import '../../assets/styles/components/_tables.scss'
import '../../assets/styles/components/_content-card.scss'
import '../../assets/styles/components/_datacard.scss'
import '../../assets/styles/components/_modal.scss'

import EditIcon from '../../assets/icons/edit.svg'
import PlusIcon from '../../assets/icons/plus-small.svg'
import CrossIcon from '../../assets/icons/cross.svg'
import UserAddLoader from './Loader/UserAddLoader';
import {useSelector} from "react-redux";
import Loader from "../Users/Loader/Loader";

const methods = {
  mapDataToRequest: (form, state) => {
    let roles = []

    if (form.roles.goodsSpecialist) {
      roles.push("GOODS_SPECIALIST")
    }
    if (form.roles.accountant) {
      roles.push("ACCOUNTANT")
    }
    if (form.roles.admin) {
      roles.push("ADMIN")
    }
    if (form.roles.director) {
      roles.push("DIRECTOR")
    }
    if (form.roles.marketer) {
      roles.push("MARKETER")
    }
    if (form.roles.branchDirector) {
      roles.push("BRANCH_DIRECTOR")
    }
    if (form.roles.loyalGoodsSpecialist) {
      roles.push("LOYAL_GOODS_SPECIALIST")
    }

    return {
      ...form.user,
      documents: state.documents,
      roles: roles
    }
  }
}

const UserAdd = ({ history, setTitlePage }) => {
  const { accessFeatures, isLoadingConfiguration } = useSelector(({user}) => user)
  const [state, setState] = useState({
    showModalUserPassword: false,
    showModalDocs: false,
    documents: [],
    currentDocument: {},
    loading: false,
    commonError: '' || null,
    errorPersonalNumber: '' || null,
    login: "",
    password: ""
  })

  useEffect(() => {
    accessFeatures['title.header_section'] && setTitlePage('Пользователи');
  }, [isLoadingConfiguration])

  const handleOpenModalUserPassword = () => setState(prev => ({ ...prev, showModalUserPassword: true }))

  const handleCloseModalUserPassword = () => history.push('/users')

  const onSubmit = form => {

    const attorneyEndDate = form.user.attorney.attorneyEndDate 
    attorneyEndDate 
    ? form.user.attorney.attorneyEndDate = moment(attorneyEndDate).utc().format('YYYY-MM-DD')
    : form.user.attorney.attorneyEndDate = null

    setState(prev => ({
      ...prev,
      loading: true,
      commonError: null
    }))

    if (state.documents.length === 0) {
      setState(prev => ({
        ...prev,
        loading: false,
        commonError: "Необходимо добавить документ"
      }))
      window.scrollTo(0, 0)
      return
    }

    let data = methods.mapDataToRequest(form, state)
    userService.createUser(data).then(response => {
      setState(prev => ({
        ...prev,
        loading: false,
        login: response.data.username,
        password: response.data.password
      }))
      handleOpenModalUserPassword()
    }).catch(error => {
      if (error.response) {
        let errorData = error.response.data
        let commonError = messages["0"]
        let errorPersonalNumber;
        if (errorData.errorCode) {
          if(errorData.errorCode === 17003){
            errorPersonalNumber = messages[errorData.errorCode]
            commonError = ''
          } else {
            commonError = messages[errorData.errorCode]
          }
        }
        window.scrollTo(0, 0)
        setState(prev => ({ ...prev, commonError: commonError , errorPersonalNumber: errorPersonalNumber}))
      }
      setState(prev => ({ ...prev, loading: false }))
    })
  }

  const handleError = () => {
    setState(prev => ({...prev, errorPersonalNumber: ''}))
  }

  const handleEditDocument = () => {
    let document = state.documents[0]
    if (document.authority && !document.authority.label) document.authority = {value: 0, label: document.authority}
    for (let prop in document) {
      if (document.hasOwnProperty(prop)) {
        if (document[prop] instanceof Date) {
          document[prop] = moment(document[prop]).toISOString().substr(0, 10)
        }
      }
    }
    setState(prev => ({ ...prev, currentDocument: document }))
  }

  const handleAddDocument = () => {
    setState(prev => ({ ...prev, currentDocument: {} }))
    handleOpenModalDocs()
  }

  const onDocumentSubmit = document => {
    if (document.authority && document.authority.label) document.authority = document.authority.label
    setState(prev => ({
      ...prev,
      commonError: '',
      documents: [document] }))
    handleCloseModalDocs()
  }

  const handleOpenModalDocs = () => setState(prev => ({ ...prev, showModalDocs: true }))

  const handleCloseModalDocs = () => setState(prev => ({ ...prev, showModalDocs: false }))

  return (
      <main className="app-content">
        { isLoadingConfiguration ?
          (<div className="content-inner">
              <Loader pageRange={1}/>
            </div>) :
          (<>
            <div className={accessFeatures['title.header_section'] ? '' : 'content-header'}>
              <div className={accessFeatures['title.header_section'] ? 'content-header-back-without-title' : 'content-header-back'}>
                <BackButton />
              </div>
              {!accessFeatures['title.header_section'] && <h1>Пользователи</h1> }
            </div>
            <div className="content-inner">
              <div className="content-inner-data">
                {state.commonError && <Message type={"error"} text={state.commonError} />}
                <div className="content-inner-data-container">
                  <HookForm
                    onSubmit={onSubmit}
                    validationSchema={userScheme}>
                    {state.loading  && <UserAddLoader/> }
                    <div className={state.loading ? "d-none" : ""}>
                      <fieldset>
                        <div className="content-section-title">
                          <h2>Создание пользователя</h2>
                          <h3>Персональные данные</h3>
                        </div>
                        <UserInfoAdd
                          h="true"
                          error={state.errorPersonalNumber}
                          onFocus={handleError}
                        />
                        <div className="form-element">
                          <label className="form-element-label" htmlFor="clientWhereKnowAboutUs">Роль</label>
                          <div className="form-element-data">
                            <div className="form-element-data-checkboxes">
                              <HCheckbox h="true" label={'Товаровед'} name={'roles.goodsSpecialist'} />
                              <HCheckbox h="true" label={'Бухгалтер'} name={'roles.accountant'} />
                              <HCheckbox h="true" label={'Администратор'} name={'roles.admin'} />
                              <HCheckbox h="true" label={'Директор'} name={'roles.director'} />
                              <HCheckbox h="true" label={'Маркетолог'} name={'roles.marketer'} />
                              <HCheckbox h="true" label={'Директор филиала'} name={'roles.branchDirector'} />
                              {accessFeatures['report.remotely_reports'] && <HCheckbox h="true" label={'Лояльный товаровед'} name={'roles.loyalGoodsSpecialist'} />}
                            </div>
                          </div>
                        </div>
                      </fieldset>
                      <fieldset>
                        <div className="content-section-title">
                          <h3>Доверенность</h3>
                        </div>
                        <UserAttorneyAdd h="true" />
                      </fieldset>
                      <fieldset>
                        <div className="content-card">
                          <div className="content-card-title">
                            <h3>Документы</h3>
                            <div className="content-card-title-actions">
                              {
                                state.documents.length === 0
                                  ? <button
                                    className="button-icontrigger caption noborder"
                                    onClick={handleAddDocument}
                                    type="button"
                                  >
                                    <span className="icon"><PlusIcon /></span>
                                    <span>Добавить</span>
                                  </button>
                                  : null
                              }
                              { state.documents.length !== 0 &&
                                <div className="datacard-header">
                                  <button type="button"
                                          className="button-icontrigger caption noborder"
                                          onClick={() => {
                                            handleEditDocument()
                                            handleOpenModalDocs()
                                          }}>
                              <span className="icon">
                                <EditIcon />
                              </span>
                                    <span>Редактировать</span>
                                  </button>
                                </div>
                              }
                            </div>
                          </div>
                          {state.documents.length !== 0 &&
                            <div className="content-card-content">
                              {state.documents.map(( document ) =>
                                <div className="datacard-body" key={document.documentNumber}>
                                  <UserDocumentsView documentInfo={ document } />
                                </div>
                              )}
                            </div>}
                        </div>
                      </fieldset>
                    </div>
                    <div className="content-inner-data-container-footer">
                      <button className="button" type="submit">Добавить</button>
                      <button className="button-light" onClick={() => history.goBack()} type="button">Отменить</button>
                    </div>
                  </HookForm>
                  <ReactModal
                    isOpen={state.showModalDocs}
                    contentLabel="Modal"
                    className="modal-container document-modal"
                    overlayClassName="modal-overlay"
                  >
                    <HookForm
                      onSubmit={(document) => onDocumentSubmit(document)}
                      validationSchema={userDocumentScheme}
                      defaultValues={state.currentDocument}
                      submitOnEnterPress = {true}>
                      <div className="modal-header">
                        <h2>Добавить документ</h2>
                        <button type="button" className="button-icontrigger modal-closetrigger" onClick={handleCloseModalDocs}>
                      <span className="icon">
                        <CrossIcon />
                      </span>
                        </button>
                      </div>
                      <div className="modal-body">
                        <UserDocumentsAdd h="true" />
                      </div>
                      <div className="modal-footer">
                        <button type="submit" className="button">Сохранить</button>
                        <button type="button" className="button-light" onClick={handleCloseModalDocs}>
                          Отменить
                        </button>
                      </div>
                    </HookForm>
                  </ReactModal>
                  <ReactModal
                    isOpen={state.showModalUserPassword}
                    contentLabel="Modal"
                    className="modal-container"
                    overlayClassName="modal-overlay"
                  >
                    <div className="modal-header">
                      <h2>Пользователь создан</h2>
                      <button type="button" className="button-icontrigger modal-closetrigger" onClick={handleCloseModalUserPassword}>
                    <span className="icon">
                      <CrossIcon />
                    </span>
                      </button>
                    </div>
                    <div className="modal-body">
                      <div className="form-element">
                        <label className="form-element-label" htmlFor="#">Логин</label>
                        <div className="form-element-data">
                          <div className="form-element-data-text">
                            <p>{state.login}</p>
                          </div>
                        </div>
                      </div>
                      <div className="form-element">
                        <label className="form-element-label" htmlFor="#">Пароль</label>
                        <div className="form-element-data">
                          <div className="form-element-data-text">
                            <p>{state.password}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ReactModal>
                </div>
              </div>
            </div>
          </>)
        }

      </main>
  )
}

export default withRouter(UserAdd)
